import React from "react";
import PersonalDataStepShared from "../common/components/PersonalDataStep/PersonalDataStepShared";
import { useDataProtectionPath } from "../common/hooks/useDataProtectionPath";

/**
 * Product (equipment) rental customer-data step. Thin wrapper over the shared,
 * prop-gated {@link PersonalDataStepShared} (issue #868). Like SUP it collects
 * only the base fields (name / email / phone, + USC for USC partners) and shows
 * an agreement *notice* — agreed on mount via `showAgreement`. Unlike SUP it
 * links terms to the tenant's dedicated terms-of-service hint page when one
 * exists (`useDataProtectionPath`).
 */
const PersonalDataStep = () => {
  const dataProtectionPath = useDataProtectionPath();
  return (
    <PersonalDataStepShared
      showAgreement
      dataProtectionPath={dataProtectionPath}
    />
  );
};

export default PersonalDataStep;
